<template>
  <v-dialog v-model="dialog">
    <v-toolbar dense color="primary" dark>
      <v-toolbar-title>
        {{ $t('titles.global.newModel', { field: $tc('models.team', 1) }) }}
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-label>{{ $tc('models.entity') }}</v-label>
        <v-divider />
        <v-flex v-if="team.entityExists" xs12 md6 px-2>
          <entity-field
            v-if="!predata.entityId"
            v-model="team.entityId"
            :label="$tc('models.entity')"
          />
          <entity-field
            v-else
            v-model="predata.entityId"
            :label="$tc('models.entity')"
          />
        </v-flex>
        <v-layout v-else wrap row>
          <v-flex md4 xs12>
            <v-text-field
              v-model="team.entityName"
              v-validate="'required'"
              :label="$t('fields.global.name') + ' (*)'"
              :data-vv-name="$t('fields.global.name')"
              :error-messages="errors.collect($t('fields.global.name'))"
            />
          </v-flex>
          <v-flex lg4 md4 xs12 px-2>
            <CountryField
              v-model="team.countryId"
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.country') })
              "
              autocomplete="new-text"
              browser-autocomplete
            />
          </v-flex>
          <v-flex lg4 md4 xs12>
            <RegionField
              v-model="team.regionId"
              :disabled="!team.countryId"
              :country-id="team.countryId"
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.region') })
              "
              autocomplete="new-text"
              browser-autocomplete
            />
          </v-flex>
        </v-layout>
        <v-flex xs12 md12>
          <v-switch
            v-model="team.entityExists"
            :label="$t('action.buttons.existsEntity')"
            color="primary"
          />
        </v-flex>
        <v-label>{{ $tc('models.team', 1) }}</v-label>
        <v-divider />
        <v-layout wrap row>
          <v-flex xs12 md6 px-2>
            <v-text-field
              v-model="team.teamWord"
              v-validate="'required'"
              :autofocus="true"
              :label="$t('titles.global.word') + ' (*)'"
              :data-vv-name="$t('titles.global.word')"
              :error-messages="errors.collect($t('titles.global.word'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <category-menu
              v-if="!predata.categoryId"
              v-model="team.categoryId"
              v-validate="'required'"
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.category') }) +
                ' (*)'
              "
              :data-vv-name="$tc('models.category')"
              :error-messages="errors.collect($tc('models.category'))"
            />
            <category-menu
              v-else
              v-model="predata.categoryId"
              v-validate="'required'"
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.category') }) +
                ' (*)'
              "
              :data-vv-name="$tc('models.category')"
              :error-messages="errors.collect($tc('models.category'))"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <span style="color: red">*</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="create" @click="submit()" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EntityField from '../Input/EntityField.vue'
import CategoryMenu from '@/components/management/categories/CategoryMenu'
import CountryField from '@/components/widgets/Input/CountryField'
import RegionField from '@/components/widgets/Input/RegionField'
import { apiAxios } from '@/helpers'
export default {
  components: {
    EntityField,
    CountryField,
    RegionField,
    CategoryMenu,
  },
  props: {
    dialog: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    predata: {
      type: Object,
    },
  },
  data() {
    return {
      team: {
        entityExists: true,
      },
      loading: false,
    }
  },
  watch: {
    'team.entityExists': function (value) {
      if (value) {
        this.team.entityId = null
      }
    },
  },
  methods: {
    cancel() {
      this.$emit('close')
    },
    async submit() {
      this.loading = true
      if (this.predata.entityId) this.team.entityId = this.predata.entityId
      if (this.predata.categoryId)
        this.team.categoryId = this.predata.categoryId
      await apiAxios
        .post('matches-create/team-entity', this.team)
        .then((response) => {
          this.$emit('createdTeam', response.data.data.result, this.type)
        })
        .finally(() => {
          this.loading = false
          this.cancel()
          this.clear()
        })
    },
    clear() {
      this.team = {}
      this.team.entityExists = true
    },
  },
}
</script>

<style></style>
